var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5625 29.0625C22.5706 29.0625 29.0625 22.5706 29.0625 14.5625C29.0625 6.55437 22.5706 0.0625 14.5625 0.0625C6.55437 0.0625 0.0625 6.55437 0.0625 14.5625C0.0625 22.5706 6.55437 29.0625 14.5625 29.0625ZM24.0273 9.75781C23.5352 10.4961 22.9023 11.1289 22.1992 11.6562V12.1484C22.1992 17.0352 18.5078 22.625 11.7227 22.625C9.61328 22.625 7.67969 22.0273 6.0625 20.9727C6.34375 21.0078 6.625 21.043 6.94141 21.043C8.66406 21.043 10.2461 20.4453 11.5117 19.4609C9.89453 19.4258 8.52344 18.3711 8.06641 16.8945C8.0941 16.8985 8.12134 16.9024 8.14824 16.9063C8.36041 16.9372 8.55113 16.9648 8.76953 16.9648C9.08594 16.9648 9.4375 16.8945 9.71875 16.8242C8.03125 16.4727 6.76562 14.9961 6.76562 13.2031V13.168C7.25781 13.4492 7.85547 13.5898 8.45312 13.625C7.43359 12.957 6.80078 11.832 6.80078 10.5664C6.80078 9.86328 6.97656 9.23047 7.29297 8.70312C9.12109 10.918 11.8633 12.3945 14.9219 12.5703C14.8516 12.2891 14.8164 12.0078 14.8164 11.7266C14.8164 9.6875 16.4688 8.03516 18.5078 8.03516C19.5625 8.03516 20.5117 8.45703 21.2148 9.19531C22.0234 9.01953 22.832 8.70312 23.5352 8.28125C23.2539 9.16016 22.6914 9.86328 21.918 10.3203C22.6562 10.25 23.3945 10.0391 24.0273 9.75781Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackTwitterLogo);
export default __webpack_public_path__ + "static/media/black-twitter-logo.0ce7e63f7d6a2d360ca151f368d35402.svg";
export { ForwardRef as ReactComponent };